import React from "react";
import { render, screen, fireEvent } from "@testing-library/react";
import "@testing-library/jest-dom";

import { FullPageChatLayout } from "./FullPageChatLayout";

jest.mock("@metalmind-ab/mmagent-chat-ui", () => ({
  ChatMessage: () => null,
  JobProgressIndicator: () => null,
  useChatStore: (selector: (state: any) => any) =>
    selector({
      backgroundJobs: [],
      removeBackgroundJob: jest.fn(),
      messages: [],
    }),
}));

beforeAll(() => {
  Object.defineProperty(HTMLElement.prototype, "scrollIntoView", {
    configurable: true,
    value: jest.fn(),
  });
  Object.defineProperty(URL, "createObjectURL", {
    configurable: true,
    value: jest.fn(() => "blob:test-url"),
  });
  Object.defineProperty(URL, "revokeObjectURL", {
    configurable: true,
    value: jest.fn(),
  });
});

const renderLayout = (
  overrides: Partial<React.ComponentProps<typeof FullPageChatLayout>> = {},
) =>
  render(
    <FullPageChatLayout
      messages={[]}
      onSendMessage={jest.fn()}
      isLoading={false}
      conversations={[]}
      onLoadConversation={jest.fn()}
      onNewConversation={jest.fn()}
      onSearchConversations={jest.fn()}
      onLoadMoreConversations={jest.fn()}
      conversationsLoading={false}
      currentConversationId={1}
      welcomeTitle="Welcome to WS"
      welcomeDescription="Start a new conversation"
      {...overrides}
    />,
  );

// #4528: the background message-sync poll halts on a 413 (a stored row too
// large to page) instead of retrying every 10s forever. This is the visible
// half of that fix -- the banner a user sees once, not the polling-halt
// logic itself (Chat.tsx has no render harness to extend within this fix's
// scope; that half is verified by direct code reading against the
// established 401/403 "stop retrying" precedent in
// the chat package's server-owned conversation stream.
describe("FullPageChatLayout messages-sync-error surface", () => {
  it("renders the sync-error banner without hiding the welcome/history content", () => {
    renderLayout({
      messagesSyncError:
        "This conversation has a message too large to sync automatically.",
    });

    expect(
      screen.getByText(
        "This conversation has a message too large to sync automatically.",
      ),
    ).toBeInTheDocument();
    // Unlike historyLoadFailed, an existing conversation's content is not
    // replaced -- the welcome/empty-state content (or messages, in a real
    // conversation) stays exactly as it was.
    expect(screen.getByText("Welcome to WS")).toBeInTheDocument();
  });

  it("renders nothing when there is no sync error", () => {
    renderLayout({ messagesSyncError: null });

    expect(
      screen.queryByText(/too large to sync automatically/i),
    ).not.toBeInTheDocument();
  });

  it("dismisses the banner via onDismissMessagesSyncError", () => {
    const onDismiss = jest.fn();
    renderLayout({
      messagesSyncError:
        "This conversation has a message too large to sync automatically.",
      onDismissMessagesSyncError: onDismiss,
    });

    fireEvent.click(screen.getByRole("button", { name: "Dismiss" }));

    expect(onDismiss).toHaveBeenCalledTimes(1);
  });
});
